import { Button } from 'ht-styleguide';

type AddSkuButtonProps = {
  action: BaseAnyFunction;
  itemDisplayPrice: string | number;
  showButtonPrice?: boolean;
  isConfirmation?: boolean;
  isEdit: boolean;
  icon?: string;
};

const AddSkuButton = ({ action, itemDisplayPrice, showButtonPrice = false, isConfirmation = false, isEdit, icon }: AddSkuButtonProps) => {
  let title = 'Add to Cart';

  if (isConfirmation) {
    title = 'Next';
  }
  if (isEdit) {
    title = 'Update';
  }

  return (
    <Button onClick={action} icon={icon}>
      {title}
      {showButtonPrice && <span>{itemDisplayPrice}</span>}
    </Button>
  );
};

export default AddSkuButton;
